import { useEffect } from "react"

export const useFreeze = () => {
  // Disable body scrolling when mobile menu open
  useEffect(() => {
    document.body.style.overflowY = "hidden"
    return () => {
      document.body.style.overflowY = "unset"
    }
  }, [])
}
